import { map } from "lodash";
import { parseQuestionnaireDate } from "../../../../../utils/DateUtils";
import EncounterEntries from "../EncounterEntries";
// function to remove NullObjects & arrays
function removeNull(arr) {
  return arr.filter((element) => element !== null);
}
const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;
function printQuestionsAndAnswers(arr, entries) {
  for (let o = 0; o < arr.length; o++) {
    if (arr[o]) {
      if (arr[o]?.answer?.value === "true") {
        entries.push({ text: `${arr[o]?.text}: ${" Yes\n"}` });
      } else if (arr[o]?.answer?.value === "false") {
        entries.push({ text: `${arr[o]?.text}: ${" No\n"}` });
      } else if (dateRegex.test(arr[o]?.answer?.value)) {
        entries.push({
          text: `${arr[o]?.text}: ${parseQuestionnaireDate(arr[o]?.answer)}`,
        });
      } else if (arr[o]?.text !== undefined && arr[o]?.answer?.value) {
        entries.push({
          text: `${arr[o]?.text}: ${
            arr[o]?.answer?.value?.display
              ? arr[o]?.answer?.value.display
              : arr[o]?.answer?.value
          }`,
        });
      } else if (
        arr[o]?.text !== undefined &&
        Array.isArray(arr[o]?.answer) &&
        arr[o]?.answer.length > 0
      ) {
        entries.push({
          text: `${arr[o]?.text}: ${map(arr[o].answer, "value.display").join(
            ", ",
          )}`,
        });
      }
      if (arr[o]?.item) {
        printQuestionsAndAnswers(arr[o].item, entries);
      }
    }
  }
}

export const renderSocialHistoryEntry = (entry, readonly) => {
  const { item, note } = entry;

  const entries = [];

  if (item && item.length > 0) {
    // use function that removes null object and arrays
    // pass new object to variables
    const newItem = removeNull(item);

    printQuestionsAndAnswers(newItem, entries);
  }

  if (note?.length > 0) {
    note.forEach((n) => {
      entries.push({ text: `${n.text}` });
    });
  }
  return (
    <EncounterEntries type="history" entries={entries} readonly={readonly} />
  );
};
